export default function PHP_timezone_offset_get() {
  return (
    <div>
      <h1>PHP_timezone_offset_get</h1>
    </div>
  );
}
